module.exports = __webpack_public_path__ + "static/media/insect(33).51d72907.PNG";